import React, { useEffect } from "react";
import { connect } from "react-redux";
import get from "../../utils/get";
import CreatePasswordScreen from "../screens/CreatePasswordScreen";
import * as actions from "../actions/create";

const CreatePasswordContainer = (props) => {
  useEffect(() => {});
  const token = props.match.params.token;

  return (
    <CreatePasswordScreen
      {...props}
      createInitialPassword={props.createInitialPassword}
      token={token}
    />
  );
};

const mapStateToProps = (state) => ({
  isLoading: get(state, "users.create.isLoading"),
  message: get(state, "users.create.message"),
});

const mapActionsToProps = { ...actions };

export default connect(
  mapStateToProps,
  mapActionsToProps
)(CreatePasswordContainer);
